import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Typography } from "@mui/joy";
import { useState } from "react";

import { FadeIn } from "~/common/components";

interface FAQItem {
  question: string;
  answer: string;
}

const pricingFaqItems: FAQItem[] = [
  {
    question: "Що входить у вартість підписки?",
    answer:
      "У вартість входить відстеження заявок, щоденне оновлення статусів, Telegram-нагадування про дедлайни, доступ для команди, технічна підтримка та всі майбутні оновлення системи.",
  },
  {
    question: "Чи можу я змінити тарифний план у будь-який час?",
    answer:
      "Так, ви можете змінити тарифний план у будь-який момент. При переході на вищий план різниця буде пропорційно розрахована. При переході на нижчий план зміни набудуть чинності з наступного платіжного періоду.",
  },
  {
    question: "Що станеться, якщо я перевищу ліміт заявок?",
    answer:
      "Система автоматично запропонує вам перейти на вищий тарифний план. Ви зможете продовжити додавати заявки після оновлення підписки або видалення частини існуючих заявок.",
  },
  // {
  //   question: "Які способи оплати ви приймаєте?",
  //   answer:
  //     "Ми приймаємо оплату банківськими картами (Visa, Mastercard), а також через популярні платіжні системи. Всі платежі захищені та проходять через безпечні канали.",
  // },
  {
    question: "Чи можу я скасувати підписку?",
    answer:
      "Так, ви можете скасувати підписку в будь-який момент через налаштування акаунта. Доступ до системи збережеться до кінця оплаченого періоду.",
  },
  {
    question: "Чи є пробний період для платних тарифів?",
    answer:
      "Ви можете почати з безкоштовного тарифу Brandly FREE на 10 заявок без обмежень у часі. Це дозволить вам оцінити всі можливості системи перед переходом на платний план.",
  },
  {
    question: "Чи можна отримати індивідуальний тариф для великої компанії?",
    answer:
      "Так, для компаній з понад 2000 заявок ми пропонуємо індивідуальні умови та можливість інтеграції з вашими внутрішніми системами. Зв'яжіться з нами для обговорення деталей.",
  },
];

export const PricingFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Box
      sx={{
        py: { xs: 6, sm: 8, md: 10, lg: 12 },
        px: { xs: 2, sm: 3, md: 4, lg: 6 },
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
        }}
      >
        {/* Title */}
        <FadeIn offsetY={20} duration={300} delay={100}>
          <Typography
            level="h2"
            sx={{
              fontSize: { xs: "1.75rem", sm: "2rem", md: "2.5rem" },
              fontWeight: 700,
              lineHeight: 1.2,
              textAlign: "center",
              mb: { xs: 4, md: 6 },
            }}
          >
            Поширені запитання про тарифи
          </Typography>
        </FadeIn>

        {/* FAQ Items */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1, md: 1.5 },
          }}
        >
          {pricingFaqItems.map((item, index) => (
            <FadeIn
              key={index}
              offsetY={20}
              duration={300}
              delay={150 + index * 50}
            >
              <Box
                sx={{
                  bgcolor: "background.surface",
                  borderRadius: "12px",
                  border: "1px solid",
                  borderColor: "divider",
                  overflow: "hidden",
                }}
              >
                <Box
                  component="button"
                  onClick={() => handleToggle(index)}
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: { xs: 2, md: 2.5 },
                    px: { xs: 2, md: 3 },
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "0.938rem", md: "1.063rem" },
                      fontWeight: 600,
                      pr: 2,
                    }}
                  >
                    {item.question}
                  </Typography>
                  <Box
                    sx={{
                      flexShrink: 0,
                      width: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      bgcolor:
                        openIndex === index ? "primary.500" : "neutral.100",
                      transition: "all 0.25s",
                    }}
                  >
                    {openIndex === index ? (
                      <RemoveIcon sx={{ fontSize: 20, color: "white" }} />
                    ) : (
                      <AddIcon sx={{ fontSize: 20 }} />
                    )}
                  </Box>
                </Box>

                {/* Answer */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateRows: openIndex === index ? "1fr" : "0fr",
                    transition: "grid-template-rows 0.3s ease-in-out",
                  }}
                >
                  <Box sx={{ overflow: "hidden" }}>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.875rem", md: "0.938rem" },
                        color: "neutral.600",
                        lineHeight: 1.7,
                        px: { xs: 2, md: 3 },
                        pb: { xs: 2, md: 2.5 },
                      }}
                    >
                      {item.answer}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </FadeIn>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
